import CommonStyles from 'shared/style/commonPageStyles'
import styled, {css} from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDiv,
	LogoImg: styled.img`
		height: 180px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			max-width: 100%;
		}
	`,

	Tab: styled.button`
		${({theme}) => theme.font.small_bold};

		${({$selected}) =>
			$selected &&
			css`
				${({theme}) => theme.font.small_bold};
				color: ${({theme}) => theme.color.major};
			`}
	`,
	Radio: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
	`,

	AreaHeader: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 16px;

		& > h2 {
			${({theme}) => theme.font.small_bold};
			flex: 1;
		}

		& > button {
			width: fit-content;
		}
	`,

	ModalOverlay: styled.div`
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	`,

	ModalContent: styled.div`
		background-color: white;
		border-radius: 12px;
		padding: 40px 32px;
		width: 90%;
		max-width: 400px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	`,

	ModalHeader: styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 24px;

		& > h2 {
			${({theme}) => theme.font.medium_bold};
			margin: 0;
			font-size: 20px;
		}
	`,

	ModalBody: styled.div`
		display: flex;
		flex-direction: column;
		gap: 24px;
	`,

	InputGroup: styled.div`
		display: flex;
		gap: 8px;

		& > input {
			flex: 1;
		}
		& > button {
			width: fit-content;
			height: 40px;
		}
	`,

	Input: styled.input`
		${({theme}) => theme.font.small};
		padding: 12px;
		border: 1px solid ${({theme}) => theme.color.grey3};
		border-radius: 8px;
		outline: none;
		font-size: 12px;
		width: 100%;
		height: 40px;
		&:focus {
			border-color: ${({theme}) => theme.color.major};
		}

		&::placeholder {
			color: ${({theme}) => theme.color.grey3};
		}
	`,

	ErrorText: styled.p`
		color: ${({theme}) => theme.color.error || '#ef4444'};
		font-size: 12px;
		margin-top: 4px;
		margin-bottom: 0;
	`,
}

export default Style
